import { dateToString } from './dates';
export var Statuses;
(function (Statuses) {
    Statuses["ToReview"] = "To Review";
    Statuses["Approved"] = "Approved";
    Statuses["Rejected"] = "Rejected";
    Statuses["InProgress"] = "In Progress";
    Statuses["Done"] = "Done";
})(Statuses || (Statuses = {}));
export const desiredStatusNames = [
    Statuses.ToReview,
    Statuses.Approved,
    Statuses.Rejected,
    Statuses.InProgress,
    Statuses.Done
];
export function customFieldIdToQl(fieldId) {
    return `cf[${fieldId.split('_')[1]}]`;
}
export function betweenStartAndEndQueryPart(startFieldId, endFieldId, start, end, timezoneOrOffset) {
    const tStart = customFieldIdToQl(startFieldId);
    const tEnd = customFieldIdToQl(endFieldId);
    const requestedStartDate = dateToString(start, timezoneOrOffset);
    const requestedEndDate = dateToString(end, timezoneOrOffset);
    const dateOrQuery = [
        // ---E[EE]E---
        // new request covers whole period, we want all booking "bigger"
        `(${tStart} < '${requestedStartDate}' AND ${tEnd} > '${requestedEndDate}')`,
        // ---E[E-]----
        // new request covers start of existing
        `(${tStart} < '${requestedStartDate}' AND ${tEnd} > '${requestedStartDate}')`,
        // ---[-E]E---
        // new request covers end of existing
        `(${tStart} < '${requestedEndDate}' AND ${tEnd} > '${requestedEndDate}')`,
        // ---[-E-]--- or ---[EEE]---
        // new request is inside
        `(${tStart} >= '${requestedStartDate}' AND ${tEnd} <= '${requestedEndDate}')`
    ];
    return `(${dateOrQuery.join(' OR ')})`;
}
export function relevantStatusQueryPart(configuration) {
    const allRelevantStatuses = Array.from(new Set([...configuration.confirmedStatusIds, configuration.approvedStatusId])).filter((x) => x);
    return `status in (${allRelevantStatuses.join(',')})`;
}
export function projectQueryPart(projectId) {
    return `'project' = '${projectId}'`;
}
export function issueTypeQueryPart(issueTypeId) {
    return `'issuetype' = '${issueTypeId}'`;
}
export function allFieldsOfConfig(config) {
    const set = new Set();
    set.add(config.startFieldId);
    set.add(config.endFieldId);
    set.add(config.resourceFieldId);
    return Array.from(set);
}
export async function loadAll(load, keyToCollect = 'values') {
    let result = [];
    let startAt = 0;
    let isLast = false;
    while (!isLast) {
        const response = await load(startAt);
        if (!response.ok) {
            throw new Error(`Failed to load data: ${await response.text()}`);
        }
        const json = (await response.json());
        if (!(json[keyToCollect] && Array.isArray(json[keyToCollect]))) {
            throw new Error(`Failed to load data: ${keyToCollect} was not present in the response.`);
        }
        result = [...result, ...json[keyToCollect]];
        if (typeof json.isLast === 'undefined') {
            isLast = result.length === json.total;
        }
        else {
            isLast = json.isLast;
        }
        startAt += json[keyToCollect].length;
    }
    return result;
}
export function allBookingBetweenStartAndEndJql(config, startDate, endDate) {
    // create a JQL to find booked resources between start and end date.
    return [
        projectQueryPart(config.projectId),
        issueTypeQueryPart(config.issuetypeId),
        betweenStartAndEndQueryPart(config.startFieldId, config.endFieldId, startDate, endDate),
        relevantStatusQueryPart(config)
    ].join(' AND ');
}
